import ReportApi from '../apis/report'
import CreativeApi from '../apis/creative'
import Vue from 'vue'
import { debounce } from 'lodash';

export const state = () => ({
  report_type: "",
  date_from: "",
  date_to: "",
  selected_tab: '',
  selected_cond_tab: '',
  selected_display_tab: '',
  selected_widget_name: '',
  selected_pop_up_name: '',
  selected_overlay_name: '',
  selected_popup_name: '',
  selected_new_overlay_name: '',
  selected_creative_id: '',
  default_cols: [
    {
      "name":"widget_name",
      "active": true
    },
    {
      "name":"pop_up_name",
      "active": true
    },
    {
      "name":"overlay_name",
      "active": true
    },
    {
      "name":"popup_name",
      "active": true
    },
    {
      "name":"display",
      "active": true
    },
    {
      "name":"image",
      "active": true
    },
    {
      "name":"title",
      "active": true
    },
    {
      "name":"animation",
      "active": true
    },
    {
      "name":"arrow",
      "active": true
    },
    {
      "name":"countdown",
      "active": true
    },
    {
      "name":"popup_type",
      "active": true
    },
    {
      "name":"display_pattern",
      "active": true
    },
    {
      "name":"device",
      "active": true
    },
    {
      "name":"total_value",
      "active": false
    },
    {
      "name":"cpm",
      "active": false
    },
    {
      "name":"imp",
      "active": true
    },
    {
      "name":"display_count",
      "active": true
    },
    {
      "name":"display_rate",
      "active": true
    },
    {
      "name":"click",
      "active": true
    },
    {
      "name":"ctr",
      "active": true
    },
  ],
  new_default_cols: [
    { "name": "popup_name", "active": true, "display_name": "名前(ポップアップ)" },
    { "name": "overlay_name", "active": true, "display_name": "名前(オーバーレイ)" },
    { "name": "display", "active": true, "display_name": "表示/非表示" },
    { "name": "device", "active": true, "display_name": "デバイス" },
    { "name": "image", "active": true, "display_name": "画像" },
    { "name": "title", "active": true, "display_name": "タイトル" },
    { "name": "animation", "active": true, "display_name": "アニメーション" },
    { "name": "countdown", "active": true, "display_name": "カウントダウン" },
    { "name": "popup_type", "active": true, "display_name": "種類" },
    { "name": "display_pattern", "active": true, "display_name": "表示条件" },
    { "name": "imp", "active": true, "display_name": "PV数" },
    { "name": "display_count", "active": true, "display_name": "表示数" },
    { "name": "display_rate", "active": true, "display_name": "表示率" },
    { "name": "click", "active": true, "display_name": "クリック数" },
    { "name": "ctr", "active": true, "display_name": "クリック率" },
  ],
  sorted_col: {
    name: '',
    mode: ''
  },
  custom_col_name: '',
  custom_cols: [],
  saved_custom_cols: [],
  widget_reports: [],
  pop_up_reports: [],
  overlay_reports: [],
  popup_reports: [],
  new_overlay_reports: [],
  creative_reports: [],
  date_for_select: [
    {k:'today',v:'本日'},
    {k:'yesterday',v:'昨日'},
    {k:'this_month',v:'今月'},
    {k:'last_month',v:'先月'}
  ],
  locales: {
    "widget_name": "widget名",
    "display": "表示/非表示",
    "image": "画像",
    "title": "タイトル",
    "total_value": "報酬合計",
    "cpm": "CPM",
    "imp": "imp",
    "click": "click",
    "ctr": "ctr",
    "countdown": "countdown",
  },
  is_loading: false,
  current_page: 1,
  total_records: 0,
});
export const actions = {
  async getWidget({ commit, state }) {
    commit("setLoading", true)
    const {data} = await ReportApi.widget({
      date_from: state.date_from,
      date_to: state.date_to,
      sort_column: state.sorted_col?.name,
      sort_order: state.sorted_col?.mode,
    })
    commit("setLoading", false)
    commit("setColNames",data.col_names)
    commit("setWidgetReports",data.datas)
  },
  async getPopUp({ commit, state }) {
    commit("setLoading", true)
    const {data} = await ReportApi.pop_up({
      date_from: state.date_from,
      date_to: state.date_to,
      sort_column: state.sorted_col?.name,
      sort_order: state.sorted_col?.mode,
    })
    commit("setLoading", false)
    commit("setColNames",data.col_names)
    commit("setPopUpReports",data.datas)
  },
  async getAreaPopUp({ commit, state }) {
    commit("setLoading", true)
    const {data} = await ReportApi.area_pop_up({
      date_from: state.date_from,
      date_to: state.date_to,
      sort_column: state.sorted_col?.name,
      sort_order: state.sorted_col?.mode,
    })
    commit("setLoading", false)
    commit("setColNames",data.col_names)
    commit("setPopUpReports",data.datas)
  },
  async getOverlayImage({ commit, state }) {
    commit("setLoading", true)
    const {data} = await ReportApi.overlay_image({
      date_from: state.date_from,
      date_to: state.date_to,
      sort_column: state.sorted_col?.name,
      sort_order: state.sorted_col?.mode,
    })
    commit("setLoading", false)
    commit("setColNames",data.col_names)
    commit("setOverlayReports",data.datas)
  },
  getPopup: debounce(async ({ commit, state }) => { // 3回短時間でapi叩かれていたのでdebouce付与
    commit("setLoading", true);
    const {data} = await ReportApi.popup({
      date_from: state.date_from,
      date_to: state.date_to,
      cond: state.selected_cond_tab,
      display: state.selected_display_tab,
      page: state.current_page,
      sort_column: state.sorted_col?.name,
      sort_order: state.sorted_col?.mode,
    })
    commit("setLoading", false)
    commit("setColNames", data.col_names)
    commit("setPopupReports", data.datas)
    commit("setTotalRecords", data.total_records)
  }, 500),
  async getNewOverlayImage({ commit, state }) {
    commit("setLoading", true)
    const {data} = await ReportApi.new_overlay_image({
      date_from: state.date_from,
      date_to: state.date_to,
      cond: state.selected_cond_tab,
      display: state.selected_display_tab,
      page: state.current_page,
      sort_column: state.sorted_col?.name,
      sort_order: state.sorted_col?.mode,
    })
    commit("setLoading", false)
    commit("setColNames",data.col_names)
    commit("setNewOverlayReports",data.datas)
    commit("setTotalRecords", data.total_records)
  },
  async getCreative({ commit, state }) {
    commit("setLoading", true)
    const {data} = await ReportApi.creative({
      widget_name: state.selected_widget_name,
      pop_up_name: state.selected_pop_up_name,
      overlay_name: state.selected_overlay_name,
      popup_name: state.selected_popup_name,
      new_overlay_name: state.selected_new_overlay_name,
      date_from: state.date_from,
      date_to: state.date_to,
      report_type: state.report_type,
      cond: state.selected_cond_tab,
      display: state.selected_display_tab,
      page: state.current_page,
      sort_column: state.sorted_col?.name,
      sort_order: state.sorted_col?.mode,
    })
    commit("setLoading", false)
    commit("setColNames",data.col_names)
    commit("setCreativeReports",data.datas)
    commit("setTotalRecords", data.total_records)
  },
  async getScenario({ commit, state }) {
    commit("setLoading", true)
    const { data } = await ReportApi.scenario_popup({
      date_from: state.date_from,
      date_to: state.date_to,
      page: state.current_page,
      cond: state.selected_cond_tab,
      display: state.selected_display_tab,
      sort_column: state.sorted_col?.name,
      sort_order: state.sorted_col?.mode,
    })
    commit("setLoading", false)
    commit("setColNames", data.col_names)
    commit("setPopupReports", data.datas)
    commit("setTotalRecords", data.total_records)
  },
  async toggleCreativeDisplay({commit, state}, {url_token}){
    const response = await CreativeApi.toggle_display({
      url_token: url_token
    });
    commit("setCreativeDisplayToggle", { url_token, display: response.data.display });
  },
  async toggleAllCreativeDisplay({ commit }, { url_token }) {
    try {
      const response = await CreativeApi.toggle_all_display({ url_token });
      commit("setAllCreativeDisplay", { url_token, display: response.data.display });
    } catch (error) {
      console.error("Error toggling display for all creatives:", error);
    }
  },
  async getCvColNames({ commit, state }){
    const {data} = await ReportApi.cv_tag_names()
    data.forEach((name)=>{
      commit("addDefaultCols", name)
    })
  },
  async saveCustomCol({commit, state, getters}){
    const {data} = await ReportApi.save_custom_col({
      custom_col_name: state.custom_col_name,
      selected_tab: state.selected_tab,
      custom_cols: getters.active_cols.map(col => col.name),
    })
    commit("setCustomCols", getters.active_cols.map(col => col.name))
    commit("setCustomColName", state.custom_col_name)
    return data
  },
  async loadCustomColNames({commit, state}){
    const {data} = await ReportApi.custom_col_names({
      selected_tab: state.selected_tab,
    })
    commit("setSavedCustomCols", data)
  },
  async destroyCol({commit}, {custom_col_id}){
    await ReportApi.destroy_col({
      custom_col_id: custom_col_id
    })
    commit("removeCustomCol", custom_col_id)
    commit("setCustomColName", '')
  },
}
export const mutations = {
  updateDefaultCols(state) {
    if (state.report_type === 'popup' || state.report_type === 'new_overlay_image') {
      state.default_cols = state.new_default_cols;
    }
  },
  setSelectedTab(state, name){
    state.selected_tab = name
  },
  setSelectedCondTab(state, name){
    state.selected_cond_tab = name
  },
  setSelectedDisplayTab(state, name){
    state.selected_display_tab = name
  },
  setReportType(state, name){
    state.report_type = name
    this.commit('report/updateDefaultCols')
  },
  setSelectedWidgetName(state, name){
    state.selected_widget_name = name
  },
  setSelectedPopUpName(state, name){
    state.selected_pop_up_name = name
  },
  setSelectedOverlayName(state, name){
    state.selected_overlay_name = name
  },
  setSelectedPopupName(state, name){
    state.selected_popup_name = name
  },
  setSelectedNewOverlayName(state, name){
    state.selected_new_overlay_name = name
  },
  setSelectedCreativeId(state, id){
    state.selected_creative_id = id
  },
  setColNames(state, cols){
    state.col_names = cols
  },
  setWidgetReports(state, data){
    state.widget_reports = data
  },
  setPopUpReports(state, data){
    state.pop_up_reports = data
  },
  setOverlayReports(state, data){
    state.overlay_reports = data
  },
  setNewOverlayReports(state, data){
    state.new_overlay_reports = data
  },
  changeReportType(state, data) {
    state.report_type = data
  },
  setPopupReports(state, data){
    state.popup_reports = data
  },
  setCreativeReports(state, data){
    state.creative_reports = data
  },
  updateCreativeReports(state, { url_token, display }) {
    const index = state.creative_reports.findIndex(c => c.url_token === url_token);
    if (index !== -1) {
      // 既存のクリエイティブ情報を更新
      Vue.set(state.creative_reports, index, {...state.creative_reports[index], display});
    } else {
      // 新しいクリエイティブ情報を追加
      state.creative_reports.push({ url_token, display });
    }
  },
  setDateFrom(state, data){
    state.date_from = data
  },
  setDateTo(state, data){
    state.date_to = data
  },
  setCustomColName(state, name){
    state.custom_col_name = name
  },
  setCreativeDisplayToggle(state, { url_token }) {
    if (state.creative_reports.length > 0) {
      const creative = state.creative_reports.find(creative => creative.url_token === url_token);
      if (creative) {
        creative.display = !creative.display;
      } else {
        console.error('No creative found with url_token:', url_token);
      }
    } else {
      console.error('creative_reportsが空です');
    }
  },
  setAllCreativeDisplay(state, { url_token, display }) {
    state.creative_reports.forEach(creative => {
      if (creative.url_token === url_token) {
        creative.display = display;
      }
    });
  },
  addDefaultCols(state, name){
    state.default_cols.push({
      "name": name,
      "active": false
    })
  },
  setActiveCol(state, {col, bool}){
    if(col!=undefined){
      col.active = bool
    }
  },
  setDefaultCol(state, cols){
    state.default_cols = cols
  },
  setCustomCols(state, cols){
    state.custom_cols = cols
  },
  setSavedCustomCols(state, cols){
    state.saved_custom_cols = cols
  },
  selectCustomCol(state, custom_col){
    state.custom_col_name = custom_col.name
    state.custom_cols = JSON.parse(custom_col.json)
  },
  removeCustomCol(state, id){
    state.saved_custom_cols = state.saved_custom_cols.filter(col=>col.id!=id)
  },
  addSavedCustomCols(state, col){
    state.saved_custom_cols.push(col)
  },
  sortAscWidgetReport(state, col_name){
    // ソートのアルゴリズム変更によりコメントアウト
    // state.widget_reports.sort((a, b) => a[col_name] - b[col_name])
    state.sorted_col = {name: col_name, mode: "asc"}
  },
  sortDescWidgetReport(state, col_name){
    // ソートのアルゴリズム変更によりコメントアウト
    // state.widget_reports.sort((a, b) => b[col_name] - a[col_name])
    state.sorted_col = {name: col_name, mode: "desc"}
  },
  sortAscCreativeReport(state, col_name){
    // ソートのアルゴリズム変更によりコメントアウト
    // state.creative_reports.sort((a, b) => a[col_name] - b[col_name])
    state.sorted_col = {name: col_name, mode: "asc"}
  },
  sortDescCreativeReport(state, col_name){
    // ソートのアルゴリズム変更によりコメントアウト
    // state.creative_reports.sort((a, b) => b[col_name] - a[col_name])
    state.sorted_col = {name: col_name, mode: "desc"}
  },
  sortAscPopUpReport(state, col_name){
    // ソートのアルゴリズム変更によりコメントアウト
    // state.pop_up_reports.sort((a, b) => a[col_name] - b[col_name])
    state.sorted_col = {name: col_name, mode: "asc"}
  },
  sortDescPopUpReport(state, col_name){
    // ソートのアルゴリズム変更によりコメントアウト
    // state.pop_up_reports.sort((a, b) => b[col_name] - a[col_name])
    state.sorted_col = {name: col_name, mode: "desc"}
  },
  sortAscPopupReport(state, col_name){
    // ソートのアルゴリズム変更によりコメントアウト
    // state.popup_reports.sort((a, b) => a[col_name] - b[col_name])
    state.sorted_col = {name: col_name, mode: "asc"}
  },
  sortDescPopupReport(state, col_name){
    // ソートのアルゴリズム変更によりコメントアウト
    // state.popup_reports.sort((a, b) => b[col_name] - a[col_name])
    state.sorted_col = {name: col_name, mode: "desc"}
  },
  sortAscNewOverlayReport(state, col_name){
    // ソートのアルゴリズム変更によりコメントアウト
    // state.new_overlay_reports.sort((a, b) => a[col_name] - b[col_name])
    state.sorted_col = {name: col_name, mode: "asc"}
  },
  sortDescNewOverlayReport(state, col_name){
    // ソートのアルゴリズム変更によりコメントアウト
    // state.new_overlay_reports.sort((a, b) => b[col_name] - a[col_name])
    state.sorted_col = {name: col_name, mode: "desc"}
  },
  clearSortCol(state){
    state.sorted_col = {name: "", mode: ""}
  },
  setLoading(state, bool){
    state.is_loading = bool
  },
  setTotalRecords(state, total_records) {
    state.total_records = total_records
  },
  setCurrentPage(state, current_page) {
    state.current_page = current_page
  },
}
export const getters = {
  active_cols(state){
    return state.default_cols.filter((col) => {
      if(col!=undefined){
        if(col.active){
          return col
        }
      }
    })
  },
  display_col_names(state, getters) {
    var col_names = [];
    if (state.custom_col_name == "") {
        col_names = getters.active_cols.map(col => col.name);
    } else {
        col_names = state.custom_cols;
    }


    if (state.selected_tab == "widget") {
        col_names = col_names.filter(col => !["overlay_name", "display", "image", "title", "pop_up_name", "animation", "arrow", "countdown", "display_count"].includes(col));
    } else if (state.selected_tab == "overlay_image") {
        col_names = col_names.filter(col => !["display", "title", "widget_name", "pop_up_name", "popup_name", "image", "animation", "arrow", "countdown", "popup_type", "display_pattern", "device", "display_count"].includes(col));
    } else if (state.selected_tab == "pop_up") {
        col_names = col_names.filter(col => !["display", "image", "title", "widget_name", "overlay_name", "popup_name", "animation", "arrow", "countdown", "popup_type", "display_pattern", "device"].includes(col));
    } else if (state.selected_tab == "area_pop_up") {
        col_names = col_names.filter(col => !["display", "image", "title", "widget_name", "overlay_name", "popup_name", "animation", "arrow", "countdown", "popup_type", "display_pattern", "device"].includes(col));
    } else if (state.selected_tab == "new_overlay_image") {
        col_names = col_names.filter(col => !["display", "title", "widget_name", "pop_up_name", "popup_name", "image", "animation", "arrow", "countdown",  "device"].includes(col));
    } else if (state.selected_tab == "popup") {
        col_names = col_names.filter(col => !["display", "image", "title", "widget_name", "overlay_name", "pop_up_name", "animation", "arrow", "countdown",  "device"].includes(col));
    } else if (state.selected_tab == "scenario") {
        col_names = col_names.filter(col => !["display", "image", "title", "widget_name", "overlay_name", "pop_up_name", "animation", "arrow", "countdown",  "device"].includes(col));
    } else if (state.selected_tab == "creative") {
        if (state.report_type == "widget") {
            col_names = col_names.filter(col => !["pop_up_name", "widget_name", "overlay_name", "animation", "arrow", "countdown", "popup_type", "display_pattern", "device", "display_count"].includes(col));
        } else if (state.report_type == "pop_up") {
            col_names = col_names.filter(col => !["pop_up_name", "widget_name", "overlay_name", "popup_type", "display_pattern", "device"].includes(col));
        } else if (state.report_type == "scenario") {
          col_names = col_names.filter(col => !["pop_up_name", "widget_name", "overlay_name", "popup_type", "display_pattern", "device", "countdown", "title"].includes(col));
        } else if (state.report_type == "area_pop_up") {
            col_names = col_names.filter(col => !["pop_up_name", "widget_name", "overlay_name", "popup_type", "display_pattern", "device"].includes(col));
        } else if (state.report_type == "popup") {
            col_names = col_names.filter(col => !["pop_up_name", "widget_name", "overlay_name", "popup_type", "display_pattern"].includes(col));
        } else if (state.report_type == "overlay_image") {
            col_names = col_names.filter(col => !["pop_up_name", "widget_name", "title", "overlay_name", "animation", "arrow", "countdown", "popup_type", "display_pattern", "device", "display_count"].includes(col));
        } else if (state.report_type == "new_overlay_image") {
            col_names = col_names.filter(col => !["pop_up_name", "widget_name", "overlay_name", "popup_type", "display_pattern"].includes(col));
        }
    } else if (state.selected_tab == "scenario_creative") {
      col_names = col_names.filter(col => !["display", "title", "widget_name", "pop_up_name",
        "popup_name", "image", "animation", "arrow", "countdown", "popup_type",
        "display_pattern", "device", "display_count", "overlay_name", "imp", "display_rate", "click", "ctr"].includes(col));
    }
    return col_names;
  }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
